<template>
    <div>
        <v-card style="overflow: hidden">
            <div id="mapconteiner">
                <div id="mapdiv"></div>
            </div>
        </v-card>
<!-- Propriedades Proximas -->
        <v-card class="rounded-r-md rounded-l-0" color="#10303D" width="300px" height="300px">
            <v-card-title class="pt-2 map-title">
                <span>Distância entre outras propriedades</span>
                <v-spacer />
                <v-text-field v-model="distanciaEstabelecimento" :loading="loading"
                              color="#BDCCCA" outlined dense v-mask="'###'"
                              background-color="#FFFFFF" style="width: 48px" class="mt-5 mb-0" >
                    <template v-slot:append>
                        <span class="kilometer">Km</span>
                    </template>
                </v-text-field>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-list elevation="0" height="245px" style="overflow: hidden scroll" nav dense>
                    <v-list-item-group v-model="selectedItem" color="#10303D">
                        <v-list-item v-for="(item, i) in listaPropriedadesProximas" :key="i">
                            <v-list-item-content>
                                <v-list-item-title v-text="item.nmEstabelecimento" />
                            </v-list-item-content>
                            <v-list-item-action-text class="font-weight-bold" >
                                {{ item.nrDistancia.toFixed(1) + ' Km' }}
                            </v-list-item-action-text>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
        </v-card>

    </div>
</template>
<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet.markercluster"
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { mask } from 'vue-the-mask'
import {URLS} from "@/modules/pedidosRacao/resources";

export default {
    name: 'mapa-pedido',
    directives: {
        mask,
    },
    data: () => ({
        mapLayerControl: null,
        map: null,
        selectedItem: 0,
        listaPropriedadesProximas: [],
        distanciaEstabelecimento: 30,
        loading: false,
        coordMarkers: null
    }),
    methods: {
        initMap() {
            this.map = L.map("mapdiv", {
                center: [-28.319984, -51.064453],
                zoom: 5,
                worldCopyJump: true
            })
            this.mapLayerControl = L.control.layers({}, {}).addTo(this.map);

            let openStreetLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                {
                    maxZoom: 12,
                    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
                        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
                })

            let streetBasicsLayer = L.tileLayer(
                "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw",
                {
                    maxZoom: 18,
                    attribution:
                        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
                        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                        'Imagens © <a href="https://www.mapbox.com/">Mapbox</a>',
                    id: "mapbox.streets-basic"
                }
            ).addTo(this.map)

            this.mapLayerControl.addBaseLayer(streetBasicsLayer, "Básico")
            this.mapLayerControl.addBaseLayer(openStreetLayer, "Detalhado")
        },
        addMarkers() {
            let markers = L.markerClusterGroup({showCoverageOnHover: false, removeOutsideVisibleBounds: false});

            let icone = L.divIcon({
                html: '<span style="color: #FF5429"><i class="fa fa-map-marker-alt fa-2x"/></span>',
                iconSize: [20, 20],
                className: 'map-icon'
            });

            let iconePropPrinc = L.divIcon({
                html: '<span style="color: #0CA5A2"><i class="fa fa-map-marker-alt fa-3x"/></span>',
                iconSize: [20, 20],
                className: 'map-icon'
            });

            for (let i = 0; i < this.coordMarkers.length; i++) {
                const estab = this.coordMarkers[i];
                const title = estab[2];

                if (estab[4] === 0) {
                    let origem = L.marker(new L.LatLng(estab[0], estab[1]), { title: title, icon: iconePropPrinc });
                    origem.bindPopup(title);
                    origem.addTo(this.map);

                    this.map.flyTo(new L.LatLng(estab[0], estab[1]), 11);
                } else {
                    const marker = L.marker(new L.LatLng(estab[0], estab[1]), {title: title, icon: icone});
                    marker.bindPopup(title);

                    markers.addLayer(marker);
                }
            }

            markers.addTo(this.map);
        },
        loadEstabelecimentosProximos() {
            this.loading = true;
            this.$axios
                .get(
                    process.env.VUE_APP_URL_API + URLS.PEDIDORACAO + this.$route.params.id +
                    URLS.ESTABPROX,
                    {
                        params: { nr_raio: this.distanciaEstabelecimento }
                    }
                )
                .then(res => {
                    if (!res.data) return
                    if (!res.data[0].data) return

                    const resposta = res.data[0].data;

                    const propPrincipal = resposta.find(estab => estab.nrDistancia === 0)

                    this.listaPropriedadesProximas = resposta;

                    this.coordMarkers = resposta.map(v => [
                        v.nrLatitude,
                        v.nrLongitude,
                        '<strong>Produtor: </strong>' + v.nmEstabelecimento + '<br />',
                        v.idEstabelecimento,
                        v.nrDistancia
                    ])
                    this.addMarkers();
                })
                .catch(error => {
                    if (this.blConfirmado) return this.$store.commit("setSnack", { type: "error", msg: error });
                })
                .finally( () => {
                    this.loading = false;
                });
        },
        debounceLoad: _.debounce(function () { this.loadEstabelecimentosProximos(); }, 1000)
    },
    watch: {
        selectedItem(newValue, oldValue) {
            const currentValue = newValue ? newValue : oldValue

            let propSelecionada = this.listaPropriedadesProximas[currentValue];
            this.map.flyTo(new L.LatLng(propSelecionada.nrLatitude, propSelecionada.nrLongitude), 13);
        },
        distanciaEstabelecimento(newValue) {
            this.loading = newValue > 0;
            if (newValue > 0) this.debounceLoad()
        }
    },
    mounted() {
        this.loadEstabelecimentosProximos();
        this.initMap();
    },
    props: {
        blConfirmado: {
            type: Boolean,
            default: false
        },
        coordPropriedade: {}
    }
}
</script>
<style scoped lang="scss">
#mapconteiner,
.size {
  width: 550px;
  height: 300px;
}
#mapdiv, #map {
  z-index: 1;
  height: 300px;
  position: relative;
}

.map-title {
  height: 96px;
  text-align: left;
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0;
  color: white;
}

.map-icon {
  text-align: center;
  line-height: 20px;
}

.kilometer {
  color: #37565C;
  width: 9px;
  white-space: nowrap;
  text-overflow: ellipsis;
  font: normal 500 normal 10px/14px Roboto;
  margin-top: 6px;
}
</style>
